import axios from "axios"

const API_URL = process.env.API_URL
const NEXT_PUBLIC_API_URL = process.env.NEXT_PUBLIC_API_URL
const THELMA_BASE_URL = process.env.THELMA_BASE_URL
const NEXT_PUBLIC_THELMA_BASE_URL = process.env.NEXT_PUBLIC_THELMA_BASE_URL

const BASE_URL = API_URL ? API_URL : NEXT_PUBLIC_API_URL //Either client of server side
const THELMA_URL = THELMA_BASE_URL
	? THELMA_BASE_URL
	: NEXT_PUBLIC_THELMA_BASE_URL

export default axios.create({
	baseURL: BASE_URL,
	headers: { "Content-Type": "application/json" },
})

export const axiosAuth = axios.create({
	baseURL: BASE_URL,
	headers: { "Content-Type": "application/json" },
})

export { BASE_URL, THELMA_URL }
